import { apiRequest } from "../api/apiClient";
import { City } from "../types/city.types";

const ROUTE_PREFIX = "cities";

const getCities = async (
  search: string,
  lat: number,
  lng: number,
  selectedCity: City
) => {
  const params = new URLSearchParams();
  params.append("search", search);

  if (selectedCity?.city) params.append("selectedCity", selectedCity?.city);
  if (lat) params.append("lat", String(lat));
  if (lng) params.append("lng", String(lng));

  const query = params.toString();
  const { data, error } = await apiRequest("get", `/${ROUTE_PREFIX}?${query}`);

  return { data, error };
};

const getAvailableCities = async () => {
  const { data, error } = await apiRequest("get", `/${ROUTE_PREFIX}/available`);
  return { data, error };
};

const updateAvailableCity = async (cityId: string, isAvailable: boolean) => {
  const { data, error } = await apiRequest(
    "post",
    `/${ROUTE_PREFIX}/available`,
    {
      cityId,
      isAvailable,
    }
  );

  return { data, error };
};

export { getCities, getAvailableCities, updateAvailableCity };
